<template>
  <div class="h5-monitor">
    <!-- 导航栏：大棚切换 -->
    <header class="nav-header">
      <span class="nav-arrow" @click="prevZone">◀</span>
      <span class="nav-title">{{ currentZoneName || "请选择" }}</span>
      <span class="nav-arrow" @click="nextZone">▶</span>
    </header>

    <!-- 视频卡片列表 -->
    <div class="card-list" v-if="currentZoneCameras.length">
      <div
        v-for="camera in currentZoneCameras"
        :key="camera.id"
        class="video-card"
      >
        <div class="card-header">
          <div class="card-icon">
            <img src="https://strawberryai.web.shuzhiren.com/static/help-manage/video.png" alt="camera">
          </div>
          <span class="card-title">{{ camera.monitorName || "视频名称" }}</span>
        </div>
        <div class="card-video-wrap">
          <iframe
            v-if="camera.monitorUrl"
            :src="camera.monitorUrl"
            class="card-iframe"
          />
          <div v-else class="card-placeholder">暂无视频地址</div>
        </div>
      </div>
    </div>
    <div v-else class="empty-tip">当前区域暂无监控</div>
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";

export default {
  name: "H5Device",
  data() {
    return {
      monitorList: [],
      zoneNames: [], // 大棚名称列表，如 ['A区大棚','B区大棚']
      currentZoneIndex: 0,
      urlToken: "",
    };
  },
  computed: {
    currentZoneName() {
      if (!this.zoneNames.length) return "";
      const i = this.currentZoneIndex % this.zoneNames.length;
      return this.zoneNames[i < 0 ? i + this.zoneNames.length : i];
    },
    currentZoneCameras() {
      if (!this.currentZoneName) return [];
      return this.monitorList.filter(
        (item) => (item.greenhouseName || "未分组") === this.currentZoneName
      );
    },
  },
  mounted() {
    // 从URL获取token
    const token = this.$route.query.token;
    if (token) {
      this.urlToken = token;
    }
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const headers = {};
        if (this.urlToken) {
          headers['Authorization'] = 'Bearer ' + this.urlToken;
        }
        const res = await axios.post('https://strawberryai-pc.web.shuzhiren.com/wapi' + "/api/monitor/list-page", {
          page: 1,
          pageSize: 100,
        }, { headers });
        if (res.code === 200) {
          this.monitorList = res.data.list || [];
          const set = new Set();
          this.monitorList.forEach((item) => {
            set.add(item.greenhouseName || "未分组");
          });
          this.zoneNames = Array.from(set);
          if (
            this.zoneNames.length &&
            this.currentZoneIndex >= this.zoneNames.length
          ) {
            this.currentZoneIndex = 0;
          }
        }
      } catch (e) {
        console.error("获取监控列表失败:", e);
      }
    },
    prevZone() {
      if (!this.zoneNames.length) return;
      this.currentZoneIndex =
        (this.currentZoneIndex - 1 + this.zoneNames.length) %
        this.zoneNames.length;
    },
    nextZone() {
      if (!this.zoneNames.length) return;
      this.currentZoneIndex =
        (this.currentZoneIndex + 1) % this.zoneNames.length;
    },
  },
};
</script>

<style scoped lang="less">
.h5-monitor {
  min-height: 100vh;
  background: #e8e8e8;
  padding-bottom: 24px;
}

.nav-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.nav-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.nav-arrow {
  font-size: 8px;
  color: #999;
  padding: 16px 8px;
  cursor: pointer;
  user-select: none;
}

.card-list {
  padding: 12px 12px 0;
}

.video-card {
  background: #fff;
  border-radius: 3px ;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  gap: 8px;
}

.card-icon {
  width: 25px;
  height: 25px;
  color: #999999;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
  }
}

.card-title {
  font-size: 16px;
  color: #333;
}

.card-video-wrap {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  background: #000;
  border-radius: 10px ;
}

.card-iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.card-placeholder {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}

.empty-tip {
  padding: 40px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
